import React, { useState, useEffect } from 'react'
import './resetPassword.css'
import { useForm } from 'react-hook-form'
import { Link, useParams, useNavigate } from 'react-router-dom'
import logo from "../../assets/Aspom-Logo.png"
import Loader from '../../components/loader/Loader'
import {sendResetPass, getResetLink} from '../../api'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);

const ResetPassword = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [showBox, setShowBox] = useState(false)
    const {id, token} = useParams()
    const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        getValues
    } = useForm({
        mode: 'onChange'
    })

    const handleResetPassword = async (data) => {
        setIsLoading(true)
        try {
            const res = await sendResetPass(data, id)
            if(res?.success){
                reset()
                MySwal.fire({
                    icon: 'success',
                    text: res?.message,
                    showConfirmButton: true,
                    confirmButtonText: 'Okay!',
                    // timer: 3000
                }).then((result)=>{
                    if (result.isConfirmed){
                        navigate('/auth')
                    }
                })
            }else{
                MySwal.fire({
                    icon: 'error',
                    text: res?.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                text: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 3000
            });
        }
    }

    useEffect(()=>{
        const fetchPasswordLink = async () => {
            try{
                const res = await getResetLink(id, token)
                if(res?.success){
                    setShowBox(true)
                }else{
                    MySwal.fire({
                        icon: 'error',
                        text: res?.message,
                        showConfirmButton: true,
                        confirmButtonText: 'Okay!',
                        // timer: 3000
                    }).then((result)=>{
                        if (result.isConfirmed){
                            navigate('/auth/forgot-password')
                        }
                    })
                }
            }catch(error){
                console.log(error)
                MySwal.fire({
                    icon: 'error',
                    text: error?.message,
                    showConfirmButton: true,
                    confirmButtonText: 'Okay!',
                    // timer: 3000
                }).then((result)=>{
                    if (result.isConfirmed){
                        navigate('/auth/forgot-password')
                    }
                })
            }
        }

        if(id && token)fetchPasswordLink()
    },[id, token])

  return (
    <section className='forgot__page'>
        {
            showBox &&
            <div className="forgot__container">
                <div className="forgot__content-heading">
                    <div className="forgot__content-text">
                        <h1 className="forgot__form-title">
                            Reset Password
                        </h1>
                        <span className="forgot__form-subtitle">
                            Enter a new password
                        </span>
                    </div>
                    <img src={logo} alt="" className="forgot__content-logo" />
                </div>

                <form className="forgot__form" 
                onSubmit={handleSubmit(handleResetPassword)}
                >
                    <div className="forgot__form-data flex">
                        <div className='forgot__form-div'>
                            <div className="forgot__form-field">
                                <i class='bx bx-envelope forgot__form-icon'></i>
                                <label htmlFor="password" className='forgot__form-label'>
                                    New Password
                                </label>
                                <input type='password' 
                                name='password' 
                                className='forgot__form-input'
                                {...register('password', {
                                    required: 'This field is required',
                                    minLength: {
                                        value: 8,
                                        message: 'Password must be at least 8 characters long'
                                    },
                                    validate: {
                                        containsUppercase: value => /[A-Z]/.test(value) || 'Password must contain at least one uppercase letter',
                                        containsLowercase: value => /[a-z]/.test(value) || 'Password must contain at least one lowercase letter',
                                        containsNumber: value => /\d/.test(value) || 'Password must contain at least one number'
                                    }
                                })}
                                />
                            </div>
                            {errors.password && <span className="forgot__form-error">
                            {errors.password.message}</span>}
                        </div>
                        {/* CONFIRM PASSWORD */}
                        <div className='login__form-div'>
                            <i className='bx bx-lock-alt login__form-icon'></i>
                            <label htmlFor="email" className='login__form-label'>
                                Confirm New Password
                            </label>
                            <input type='password' 
                            placeholder='*************' 
                            name='cpassword' 
                            className='login__form-input'
                            {...register('cpassword',{
                            validate: (value)=>{
                                const {password} = getValues()
                                if(value !== password){
                                return 'Password not match'
                                }
                            }
                            })}
                            />
                            {errors.cpassword && <span className="login__form-error">
                            {errors.cpassword.message}</span>}
                        </div>
                        
                    </div>

                    <Link to='/auth' className='forgot__form-link'>
                        Proceed to Login
                    </Link>
                    {isLoading ? <Loader/> : <button
                    type='submit'
                    className='forgot__form-button'>Submit</button>}
                </form>

            </div>
        }
    </section>
  )
}

export default ResetPassword